import AddressProofError from './AddressProofError';
class AddressProofFileIsUnsupported extends AddressProofError {
    constructor(options) {
        super('Address proof file is not supported. Only PNG, JPG, JPEG or PDF files are accepted.', options);
    }
}
export default AddressProofFileIsUnsupported;
